import React from 'react';
import FBOButton from 'ui/theme/components/FBOButton/FBOButton';

interface GroupPropertiesProps {
  unGroup: () => void;
}

const GroupProperties: React.FC<GroupPropertiesProps> = ({ unGroup }) => {
  return (
    <>
      <FBOButton
        variant="primary"
        color="negative"
        data-qa="groupProperties"
        onClick={unGroup}
      >
        Ungroup
      </FBOButton>
    </>
  );
};

export default GroupProperties;
